<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <check-import-field-chart
                        :questions="value"
                        ref="fieldChart"
                        style="width: 500px; height: 500px"
                    ></check-import-field-chart>
                </v-col>

                <v-col>
                    <check-import-question-bank-chart
                        :questions="value"
                        ref="questionBankChart"
                        style="width: 500px; height: 500px"
                    ></check-import-question-bank-chart>
                </v-col>
            </v-row>

            <div>
                <import-question @import="importQuestion"></import-question>
                <question-paste-button
                    @paste="appendQuestion"
                    class="ml-2"
                ></question-paste-button>
                <question-copy-button
                    :questions="value"
                    class="ml-2"
                ></question-copy-button>
                <question-selection-copy-button
                    :selectedQuestionsForCopying="selectedQuestionsForCopying"
                    class="ml-2"
                ></question-selection-copy-button>
            </div>

            <div class="mt-2 body-1">Total: {{ value.length }} Pertanyaan</div>
        </v-container>

        <v-container fluid>
            <similiarity-dialog
                ref="dialog"
                :tryouts="tryouts"
            ></similiarity-dialog>
            <check-import-table
                :selectedQuestions.sync="selectedQuestionsForCopying"
                @similiarityClick="displaySimiliarityDialog"
                @similiarityChange="$emit('similiarityChange')"
                @update:questions="questionUpdated"
                :questions="value"
                :similiarities="similiarities"
                :tryouts="tryouts"
                :tryoutIdx="tryoutIdx"
            ></check-import-table>
        </v-container>
    </div>
</template>

<script>
import ImportQuestion from './ImportQuestion.vue'
import CheckImportTable from './CheckImportTable.vue'
import CheckImportFieldChart from './CheckImportFieldChart'
import CheckImportQuestionBankChart from './ChekcImportQuestionBankChart'
import SimiliarityDialog from './SimiliarityDialog.vue'
import QuestionPasteButton from './QuestionPasteButton.vue'
import QuestionCopyButton from './QuestionCopyButton.vue'
import QuestionSelectionCopyButton from './QuestionSelectionCopyButton.vue'

export default {
    props: {
        value: {
            type: Array,
        },
        similiarities: {
            type: Object,
        },
        tryouts: {
            type: Array,
        },
        tryoutIdx: {
            type: Number,
        },
    },

    components: {
        ImportQuestion,
        CheckImportTable,
        CheckImportFieldChart,
        CheckImportQuestionBankChart,
        SimiliarityDialog,
        QuestionPasteButton,
        QuestionCopyButton,
        QuestionSelectionCopyButton,
    },

    data: () => ({
        selectedQuestionsForCopying: [],
    }),

    methods: {
        questionUpdated(value) {
            this.$emit('input', value)
            this.$nextTick(() => this.renderChart())
        },
        importQuestion(imported) {
            this.$emit('input', this.value.concat(imported))
            this.renderChart()
        },
        renderChart() {
            this.$nextTick(() => this.$refs.fieldChart.render())
            this.$nextTick(() => this.$refs.questionBankChart.render())
        },
        displaySimiliarityDialog(question) {
            this.$refs.dialog.show(question)
        },
        appendQuestion(questions) {
            this.$emit('input', this.value.concat(questions))
            this.renderChart()
        },
    },
}
</script>
